export default __webpack_public_path__ + "images/8dc9eb20e618dc6fe43f48b89f284e9e-hockey_small.webp";